var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"goods-specs-item"},[_c('div',{staticClass:"name",style:({ 'width': _vm.nameWidth })},[_vm._v(_vm._s(_vm.name))]),(_vm.text)?[_c('div',{staticClass:"content"},[_c('span',{staticClass:"text"},[_vm._v(" "+_vm._s(_vm.text)+" ")])])]:[_c('div',{staticClass:"content"},[_vm._t("default")],2)]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }